import { ReactElement } from 'react';

import CasinoGames from './components/CasinoGames';
import LiveCasinoGames from './components/LiveCasinoGames';

import Section from '../../components/Section';

export default function Games(): ReactElement {
  return (
    <>
      <Section title='Live Casino Games' id='live_casino_games'>
        <LiveCasinoGames />
      </Section>
      <Section title='Casino Games' id='casino_games'>
        <CasinoGames />
      </Section>
    </>
  );
}
